import { createSlice } from '@reduxjs/toolkit';

const initialConsolidationState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    consolidationForEdit: undefined,
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const consolidationSlice = createSlice({
    name: 'consolidation-notification',
    initialState: initialConsolidationState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
                state.actionsLoading = false;
            } else {
                state.listLoading = false;
                state.actionsLoading = true;
            }
        },

        // getConsolidationById
        consolidationFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.consolidation = action.payload.consolidation;
        },
        // findConsolidation
        consolidationsFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },
        // Set to default state actionLoading & error
        consolidationReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

